(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ninety-contact"] && !Shopify.designMode) return;
  try {
    (() => {
  const initializeContacts = (root = document) => {
    root.querySelectorAll('[data-contact-form]').forEach(form => {
      if (form.dataset.contactReady) return;
      form.dataset.contactReady = 'true';
      const email = form.querySelector('[name="contact[email]"]');
      const body = form.querySelector('[name="contact[body]"]');
      const button = form.querySelector('button[type="submit"]');
      const status = form.querySelector('[data-contact-status]');
      const result = form.querySelector('[data-contact-result]');
      if (result && (location.hash === '#' + form.id || new URL(location.href).searchParams.has('contact_posted'))) result.focus();
      if (!email || !body || !button) return;
      let busy = false;
      let deadline;
      const reset = () => {busy = false; clearTimeout(deadline); button.removeAttribute('aria-busy'); button.removeAttribute('aria-disabled');};
      const grow = () => {body.style.height = 'auto'; body.style.height = Math.min(600, Math.max(160, body.scrollHeight)) + 'px';};
      body.addEventListener('input', grow);
      grow();
      [email, body].forEach(field => field.addEventListener('input', () => {
        field.removeAttribute('aria-invalid');
        form.querySelector(field === email ? '[data-email-error]' : '[data-body-error]').textContent = '';
      }));
      form.addEventListener('submit', event => {
        if (busy) {event.preventDefault(); return;}
        email.value = email.value.trim();
        let first;
        const checks = [[email, !email.value || email.validity.typeMismatch, '[data-email-error]', form.dataset.emailError], [body, !body.value.trim(), '[data-body-error]', form.dataset.bodyError]];
        checks.forEach(([field, invalid, selector, message]) => {
          form.querySelector(selector).textContent = invalid ? message : '';
          if (invalid) {field.setAttribute('aria-invalid', 'true'); first ||= field;} else field.removeAttribute('aria-invalid');
        });
        if (first) {event.preventDefault(); first.focus(); return;}
        if (form.hasAttribute('data-preview-only')) {event.preventDefault(); status.textContent = form.dataset.previewMessage; return;}
        busy = true;
        button.setAttribute('aria-busy', 'true'); button.setAttribute('aria-disabled', 'true');
        status.textContent = form.dataset.sending;
        deadline = setTimeout(() => {reset(); status.textContent = form.dataset.uncertain;}, 45000);
      });
      addEventListener('pageshow', () => {reset(); status.textContent = ''; grow();});
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeContacts()); else initializeContacts();
  document.addEventListener('shopify:section:load', event => initializeContacts(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ninety-interactions"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-catalog]').forEach(catalog => {
      if (catalog.dataset.ready) return;
      catalog.dataset.ready = 'true';
      const buttons = [...catalog.querySelectorAll('[data-series-filter]')];
      const cards = [...catalog.querySelectorAll('[data-series]')];
      const status = catalog.querySelector('[data-count]');
      const apply = value => {
        const known = buttons.some(button => button.dataset.seriesFilter === value);
        const selected = known ? value : 'all';
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.seriesFilter === selected)));
        cards.forEach(card => card.hidden = selected !== 'all' && card.dataset.series !== selected);
        if (status) status.textContent = `${cards.filter(card => !card.hidden).length} ${catalog.dataset.countLabel}`;
      };
      buttons.forEach(button => button.addEventListener('click', () => {
        const value = button.dataset.seriesFilter;
        const url = new URL(location.href);
        if (value === 'all') url.searchParams.delete('series'); else url.searchParams.set('series', value);
        history.pushState(null, '', url);
        apply(value);
      }));
      addEventListener('popstate', () => apply(new URL(location.href).searchParams.get('series') || 'all'));
      apply(new URL(location.href).searchParams.get('series') || 'all');
    });
    root.querySelectorAll('[data-order-form]').forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      form.addEventListener('submit', event => {
        const quantity = form.querySelector('[name=quantity]');
        const message = form.querySelector('[data-form-error]');
        const value = Number(quantity.value);
        if (!Number.isInteger(value) || value < 1) {
          event.preventDefault(); quantity.setAttribute('aria-invalid', 'true'); message.textContent = form.dataset.quantityError; quantity.focus(); return;
        }
        quantity.removeAttribute('aria-invalid'); message.textContent = '';
        if (form.dataset.busy) { event.preventDefault(); return; }
        form.dataset.busy = 'true';
        form.querySelector('button[type=submit]').setAttribute('aria-busy', 'true');
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize()); else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  addEventListener('pageshow', () => document.querySelectorAll('[data-order-form]').forEach(form => {delete form.dataset.busy; form.querySelector('button[type=submit]')?.removeAttribute('aria-busy');}));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ninety-newsletter"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = (root = document) => root.querySelectorAll('[data-newsletter-form]').forEach(form => {
    if (form.dataset.ready) return;
    form.dataset.ready = 'true';
    const result = form.querySelector('[data-newsletter-result]');
    if (result && location.hash === '#' + form.id) result.focus();
    const email = form.querySelector('[type=email]');
    const button = form.querySelector('[type=submit]');
    const error = form.querySelector('[data-newsletter-error]');
    const status = form.querySelector('[data-newsletter-status]');
    if (!email || !button) return;
    let busy = false;
    let deadline;
    const reset = () => {busy = false; clearTimeout(deadline); button.removeAttribute('aria-busy'); button.removeAttribute('aria-disabled');};
    email.addEventListener('input', () => {email.removeAttribute('aria-invalid'); error.textContent = '';});
    // Block repeated human actions, while allowing Shopify's protected resubmission.
    button.addEventListener('click', event => {if (busy && event.isTrusted) event.preventDefault();});
    form.addEventListener('keydown', event => {if (busy && event.isTrusted && event.key === 'Enter' && !event.isComposing) event.preventDefault();});
    form.addEventListener('submit', event => {
      if (busy) return;
      email.value = email.value.trim();
      if (!email.value || !email.validity.valid) {
        event.preventDefault(); email.setAttribute('aria-invalid', 'true'); error.textContent = form.dataset.emailError; email.focus(); return;
      }
      if (form.hasAttribute('data-preview-only')) {event.preventDefault(); status.textContent = form.dataset.previewMessage; return;}
      busy = true; button.setAttribute('aria-busy', 'true'); button.setAttribute('aria-disabled', 'true'); status.textContent = form.dataset.sending;
      deadline = setTimeout(() => {reset(); status.textContent = form.dataset.uncertain;}, 45000);
    });
    addEventListener('pageshow', () => {reset(); status.textContent = '';});
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize()); else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
